import Cookies from "js-cookie";

/**
 * Whether this tab is an admin "login as user" (impersonation) session.
 * Impersonation uses sessionStorage so the admin cookie stays intact in other tabs.
 */
export const isImpersonating = () => {
  try {
    return (
      typeof window !== "undefined" &&
      sessionStorage.getItem("impersonation") === "1"
    );
  } catch {
    return false;
  }
};

/**
 * Saves the authentication token in cookies
 * @param {string} token - The authentication token to save
 */
export const setToken = (token) => {
  Cookies.set("token", token, {
    expires: 7,
    secure: process.env.NODE_ENV === "production",
    sameSite: "Strict",
  });
};

/**
 * Retrieves the authentication token.
 * During impersonation, prefers the user token in sessionStorage over the shared admin cookie.
 * @returns {string|null} The authentication token or null if not found
 */
export const getToken = () => {
  try {
    if (isImpersonating()) {
      const impToken = sessionStorage.getItem("token");
      if (impToken) return impToken;
    }
  } catch (_) {}
  return Cookies.get("token") || null;
};

/**
 * Removes the authentication token.
 * During impersonation, only clears this tab's session flags (keeps admin cookie for other tabs).
 */
export const clearToken = () => {
  try {
    if (isImpersonating()) {
      sessionStorage.removeItem("impersonation");
      sessionStorage.removeItem("token");
      return;
    }
  } catch (_) {}
  Cookies.remove("token");
};
